import { useEffect } from "react";
import { useLocation } from "wouter";

const SCRIPT_SRC = "https://n6wxm.com/vignette.min.js";
const ZONE_ID = "11657509";
const SCRIPT_SELECTOR = `script[data-n6wxm-zone="${ZONE_ID}"]`;

function isPublicContentRoute(pathname: string) {
  return pathname === "/" ||
    pathname === "/news" ||
    pathname.startsWith("/article/") ||
    pathname.startsWith("/clubs/") ||
    pathname === "/highlights" ||
    pathname.startsWith("/matches") ||
    pathname === "/standings";
}

export default function N6wxmLoader() {
  const [location] = useLocation();

  useEffect(() => {
    if (!isPublicContentRoute(location)) return;
    if (document.querySelector(SCRIPT_SELECTOR)) return;

    let cancelled = false;
    const load = () => {
      if (cancelled || document.querySelector(SCRIPT_SELECTOR)) return;
      const script = document.createElement("script");
      script.src = SCRIPT_SRC;
      script.dataset.zone = ZONE_ID;
      script.async = true;
      script.dataset.n6wxmZone = ZONE_ID;
      document.body.appendChild(script);
    };
    const timer = window.setTimeout(load, 2500);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [location]);

  return null;
}

export { isPublicContentRoute };
